import { z } from 'zod'

export const forgotPasswordSchema = z.object({
  email: z.email('Email je v neplatnom tvare').min(1, 'Email je povinný'),
})

export type ForgotPasswordSchema = z.infer<typeof forgotPasswordSchema>
